export default "__VITE_ASSET__BVpAtkJo__"